<template>
  <MarketItemWrapper
    :index="index"
    :name="name"
    :checked="checked"
    :disabled="disabled"
    :image="image"
    :soldOut="soldOut"
    :isPurchasable="isPurchasable"
    :isUnpurchasable="isUnpurchasable"
    :notFirstPurchase="notFirstPurchase"
    :notFirstPurchaseGuest="notFirstPurchaseGuest"
    :firstPurchaseOnlyProduct="firstPurchaseOnlyProduct"
    :stockCount="stockCount"
    :retailPrice="retailPrice"
    :salePrice="salePrice"
    :quantity="quantity"
    :minCount="minCount"
    :maxCount="maxCount"
    :onChecked="onChecked"
    :onDelete="onDelete"
    :onMoveDetail="onMoveDetail"
    :returnOrExchange="false"
  >
    <VCheckBox
      v-if="!isUnpurchasable"
      slot="title"
      class="product-name"
      :name="`${name}-${index}`"
      :checked="checked"
      :onChecked="onChecked"
      :disabled="locked"
    >
      <VSpan :size="22" :color="TextColor.darkGray" :text="name" :weight="TextWeight.bold" />
    </VCheckBox>

    <VBlock v-else slot="title" class="product-name-block">
      <VSpan
        class="product-name"
        :weight="TextWeight.bold"
        :text="name"
        :size="22"
        :color="TextColor.inactive"
      />
    </VBlock>

    <div class="info-wrapper" slot="name-list">
      <VBlock v-for="(item, idx) in items" class="info-name" :key="idx" :sort="Sort.left_center">
        <VBullet :inactive="isUnpurchasable" />
        <VP
          class="name"
          :text="item.name"
          :size="16"
          :color="!isUnpurchasable ? TextColor.disable : TextColor.inactive"
        />
      </VBlock>
    </div>

    <slot></slot>
  </MarketItemWrapper>
</template>

<script>
import VBullet from '@/presentationals/v2/components/layouts/atoms/VBullet'
import VP, { TextWeight, TextColor } from '@/presentationals/v2/components/layouts/atoms/VP'
import VSpan from '@/presentationals/v2/components/layouts/atoms/VSpan'

import VCheckBox from '@/presentationals/v2/components/layouts/atoms/VCheckBox'
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

import MarketItemWrapper from '@/presentationals/v2/components/layouts/organisms/MarketItemWrapper'

export default {
  name: 'MarketSetItem',
  props: {
    index: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    soldOut: {
      type: Boolean,
      required: true
    },
    isPurchasable: {
      type: Boolean,
      required: true
    },
    isUnpurchasable: {
      type: Boolean,
      required: true
    },
    firstPurchaseOnlyProduct: {
      type: Boolean,
      required: true
    },
    notFirstPurchase: {
      type: Boolean,
      required: true
    },
    notFirstPurchaseGuest: {
      type: Boolean,
      required: true
    },
    locked: {
      type: Boolean,
      required: true
    },
    stockCount: {
      type: Number,
      required: true
    },
    salePrice: {
      type: Number,
      required: true
    },
    retailPrice: {
      type: Number,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    minCount: {
      type: Number,
      required: true
    },
    maxCount: {
      type: Number,
      required: true
    },
    onChecked: {
      type: Function,
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    },
    onMoveDetail: {
      type: Function,
      required: true
    }
  },
  components: {
    VBullet,
    VP,
    VSpan,

    VCheckBox,
    VBlock,

    MarketItemWrapper
  },
  extends: [MarketItemWrapper],
  data() {
    return {
      Direction,
      TextWeight,
      TextColor,
      Sort
    }
  }
}
</script>

<style lang="scss" scoped>
.product-name {
  width: 100%;
  line-height: 30px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-name-block {
  width: calc(100% - 50px);

  .product-name {
    width: 100%;
    line-height: 28px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.info-wrapper {
  width: 100%;
  margin-bottom: 5px;

  .info-name {
    position: relative;
    height: 17px;
    box-sizing: border-box;
    margin-bottom: 8px;

    .name {
      display: block;
      width: 100%;
      text-align: left;
      text-indent: 4px;
      margin-left: 4px;
      line-height: 18px;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>